var map = {
	"./ar/posts/BlogPage.vue": [
		1431,
		1431
	],
	"./bn/posts/BlogPage.vue": [
		7385,
		7385
	],
	"./en/posts/BlogPage.vue": [
		85,
		85
	],
	"./fa/posts/BlogPage.vue": [
		1057,
		1057
	],
	"./ur/posts/BlogPage.vue": [
		5267,
		5267
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 1487;
module.exports = webpackAsyncContext;